import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

/**
 * An nile-menu element.
 */

interface MenuItem {
  name: string;
  icon: string;
  href: string;
}

interface MenuItemList {
  [key: string]: MenuItem;
}

/**
 * An nile-sidebar element.
 *
 * @fires count-changed - Indicates when the count changes
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('nile-sidebar')
export class NileSidebar extends LitElement {
  static override styles = css`
    :host {
      background-color: var(--nile-alert-color-background-base);
      border-right: 1px solid #e5e9eb;      
      min-height: 100vh;
      background: #fafafa;
      border: 1px solid #e5e9eb;
    }
    :host([showSidebar=true]) {
      min-width: 240px;
    }
    .nile-logo {
      margin: 24px;
      display: block;
      margin-bottom: 12px;
    }

    .menu-group {
      margin-left: 24px;
      margin-right: 24px;
    }

    .view-component {
      background-color: #fff;
      min-width: 240px;
    }
    // padding: 3rem;
    .view-component__item {
      background-color: #fff;
      // padding: 1rem;
      border-radius: 3px;
      border: solid 1px #eee;
    }

    .nile-menu__hr {
      border-bottom: solid 1px rgba(0, 0, 0, 0.1);
      margin-top: 12px !important;
      margin-bottom: 12px !important;
      background-color: rgba(0, 0, 0, 0.1);
    }

    .nds-menu--bottom {
      position: absolute;
      bottom: 0;
    }

    .nds-menu--active .nile-logo {
      display: none;
    }
  `;

  /**
   * Button Lab
   */
  @property()
  title = '';

  /**
   * Hide Sidebar
   */
  @property()
  showSidebar = false;

  get buttonClassMap() {
    return {
      'nds-menu--active': this.showSidebar
    };
  }

  // class="nds-menu ${classMap(this.buttonClassMap)}"
  
  override render() {
    return html`
      <div class="nile-menu--wrapper  ${classMap(this.buttonClassMap)}" >
        <div class="nile-menu-group">
          <a class="nile-logo" href="/">
            <img
              src="https://assets.aquera.io/img/aquera-logo-blue.svg"
              alt="Aquera"
              width="112.94px"
              height="31.06px"
              tabindex="1"
            />
          </a>          
          <div class="menu-group">
            <slot name="menu"></slot>
          </div>
        </div>
        <div class="">
          <div class="nds-menu--bottom">
            <slot name="bottom"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nile-sidebar': NileSidebar;
  }
}
